import React, { useState } from 'react';
import { Button } from '../../ui/Button';

const AiKeyPanel = ({ status, busy, onSave, onRecheck, onRemove }) => {
  const [value, setValue] = useState('');
  const [replacing, setReplacing] = useState(false);
  const showForm = !status.connected || replacing;
  const invalid = status.keyStatus === 'invalid';

  const submit = async (e) => {
    e.preventDefault();
    const ok = await onSave(value.trim());
    if (ok) {
      setValue('');
      setReplacing(false);
    }
  };

  return (
    <div className="mt-4 rounded-xl border border-slate-200 bg-slate-50 p-4">
      {status.connected && (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-sm font-medium text-slate-900">
              OpenAI key ending in <span className="font-mono">{status.keyLast4}</span>
            </p>
            <span className={`mt-1 inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${invalid ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'}`}>
              {invalid ? 'Needs attention' : 'Connected and valid'}
            </span>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button variant="secondary" onClick={onRecheck} disabled={busy}>Re-check</Button>
            <Button variant="secondary" onClick={() => setReplacing(!replacing)} disabled={busy}>Replace</Button>
            <Button variant="danger" onClick={onRemove} disabled={busy}>Disconnect</Button>
          </div>
        </div>
      )}
      {showForm && (
        <form onSubmit={submit} className={status.connected ? 'mt-4' : ''}>
          <label className="block text-sm font-medium text-slate-700" htmlFor="openai-key">OpenAI API key</label>
          <input
            id="openai-key"
            type="password"
            autoComplete="off"
            spellCheck={false}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="sk-..."
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
          />
          <p className="mt-2 text-xs text-slate-500">
            Your key is checked with OpenAI, then stored encrypted on the server. It is never shown again.
          </p>
          <div className="mt-3">
            <Button type="submit" disabled={busy || value.trim().length < 20}>
              {busy ? 'Checking...' : 'Save and validate'}
            </Button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AiKeyPanel;